const LATIN_EQUIVALENTS: Record<string, string> = {
  'æ': 'ae',
  'œ': 'oe',
  'ø': 'o',
  'ł': 'l',
  'đ': 'd',
  'ð': 'd',
  'þ': 'th',
  'ß': 'ss',
  'ı': 'i',
  'ŧ': 't',
  'ħ': 'h',
};

/**
 * Normalize text for deterministic identity comparisons only.
 * This deliberately does not perform fuzzy spelling correction.
 */
export function normalizeIdentityText(value: string): string {
  return value
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[æœøłđðþßıŧħ]/g, character => LATIN_EQUIVALENTS[character] ?? character)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Match the exact same name tokens regardless of source order or punctuation. */
export function normalizePersonIdentity(value: string): string {
  return normalizeIdentityText(value).split(' ').filter(Boolean).sort().join(' ');
}
